import {WizTableForm} from "../../index";

import roleInfo from './config-roleInfo'
let roleConfig = roleInfo(this, {apiParams : {}})

const columns = () => {
    return [
        {
            title: '账号',
            name: 'userName',
            dataIndex: 'userName',
            searchItem: {},
            tableItem: {
                width: 150
            }
        },
        {
            title: '姓名',
            name: 'fullName',
            dataIndex: 'fullName',
            searchItem: {},
            tableItem: {
                width: 100
            }
        },
      /*   {
            title: '证件号码',
            name: 'idCard',
            dataIndex: 'idCard',
            searchItem: {},
            tableItem: {
                width: 150
            }
        }, */
        {
            title: '手机号',
            name: 'mobile',
            dataIndex: 'mobile',
           // searchItem: {}, //后台都没查这个字段，先注释--3173
            tableItem: {
                width: 120
            }
        },
        {
            title: '状态',
            name: 'state',
            dataIndex: 'state',
            dict: [
                { code: 1, codeName: '激活' },
                { code: 0, codeName: '禁用' },
            ],
            searchItem: {
                type: 'select',
                width: 171
            },
            tableItem: {
                width: 100
            }
        },
      // {
      //   title: "角色",
      //   name: "roleIdList",
      //   dataIndex: 'roleIdList',
      //   searchItem: {
      //     type: "select",
      //     selectType: 'radio',
      //     diy: WizTableForm,
      //     ...roleConfig,
      //   }
      // },
    ]
}

const tableApi = (api = {}) => {
    return {
        path: 'personManage/listByConfigPage',
        ...api
    }
};

const user = (self, api, otherProps = {}) => {
    return {
        type: 'diy',
        initialValue: [],
        rowkey: 'personId',
        rowTitle: 'userName',
        rowName: 'fullName',
        columns: columns(),
        tableApi: tableApi(api),
        title:'选择用户',
        setData: (list)=>{
            let listNew = []
            list && list.length && list.forEach(element => {
                if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
                    element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
                  }
                listNew.push(element);
            });
            return listNew;
        },
        ...otherProps,
    }
};

export default user
